import getOr from 'lodash/fp/getOr'
import * as yup from 'yup'
import '../../../../../utils/validations/extendYup'

const validationSchema = yup.object().shape({
  sector: yup
    .string()
    .required(),
  doing: yup
    .string()
    .required(),
  main_products: yup
    .string()
    .required(),
  targeting: yup
    .string()
    .required()
})

const mapPropsToValues = ({ application }) => ({
  sector: getOr('', 'activity.sector')(application),
  doing: getOr('', 'activity.doing')(application),
  main_products: getOr('', 'activity.main_products')(application),
  targeting: getOr('', 'activity.targeting')(application)
})

export default {
  mapPropsToValues,
  validationSchema
}
